// extracted by mini-css-extract-plugin
export default {"card":"index_card__+0CLV","connect":"index_connect__B6kIH"};